import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import Joyride, { STATUS } from 'react-joyride';

import {
    endTour,
    markStepCompleteRemote,
} from '../../../redux/actions/onboarding';
import {
    TOUR_LEARN_AUTOMATION_TEMPLATES,
    STEP_IDS,
} from '../configs/onboarding.config';

// Mapping tourId -> tour object. Plugar novos tours aqui.
const TOURS_BY_ID = {
    [TOUR_LEARN_AUTOMATION_TEMPLATES.id]: TOUR_LEARN_AUTOMATION_TEMPLATES,
};

class ProductTour extends Component {
    handleCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            const { activeTourId } = this.props.onboarding || {};

            // Tour 'learn-automation-templates' é o único step manual.
            // Ao terminar, marca via endpoint POST /api/onboarding/me/step/.../complete
            if (activeTourId === TOUR_LEARN_AUTOMATION_TEMPLATES.id) {
                this.props.markStepCompleteRemote(STEP_IDS.LEARN_AUTOMATION_TEMPLATES);
            }

            this.props.endTour();
        }
    };

    render() {
        const { activeTourId } = this.props.onboarding || {};
        if (!activeTourId) return null;

        const tour = TOURS_BY_ID[activeTourId];
        if (!tour) return null;

        const { intl } = this.props;

        return (
            <Joyride
                steps={tour.steps}
                run
                continuous
                showProgress
                showSkipButton
                disableCloseOnEsc={false}
                disableOverlayClose={false}
                callback={this.handleCallback}
                styles={{
                    options: {
                        primaryColor: '#8BC34A',
                        zIndex: 10000,
                        arrowColor: '#fff',
                        textColor: '#212121',
                    },
                    tooltip: {
                        borderRadius: 12,
                        padding: 20,
                    },
                    buttonNext: {
                        backgroundColor: '#8BC34A',
                        borderRadius: 8,
                    },
                    buttonBack: { color: '#555' },
                    buttonSkip: { color: '#888' },
                }}
                locale={{
                    back: intl.formatMessage({ id: 'onboarding.tour.back' }),
                    close: intl.formatMessage({ id: 'onboarding.tour.close' }),
                    last: intl.formatMessage({ id: 'onboarding.tour.last' }),
                    next: intl.formatMessage({ id: 'onboarding.tour.next' }),
                    skip: intl.formatMessage({ id: 'onboarding.tour.skip' }),
                }}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    onboarding: state.onboarding,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ endTour, markStepCompleteRemote }, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductTour));
